import { UserCircleIcon } from '@heroicons/react/24/outline';
import { Avatar } from '@mantine/core';

export default function UserProfile() {
  return (
    <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
      <div className="flex items-center justify-between p-4 border-b">
        <div className="md:flex items-center gap-4">
            {/* <UserCircleIcon className="w-16 h-16 text-yellow-400 border-2 border-yellow-400 rounded-full bg-white" aria-hidden="true" /> */}
            <Avatar radius='xl' />
        <div>
          
         
          <p className="text-lg font-semibold">Jessica Mittal</p>
          
        </div>
        <div className="lg:ml-6 text-sm text-gray-500">
          UID <span className="font-mono">1134981865</span>
        </div>
        <div className="lg:ml-6 text-sm text-gray-500">
          VIP Level: <span className="font-semibold">Regular User</span>
        </div>
      </div>
    </div>
    </div>
  );
}
